import { assert_false } from '@shared/asserts/utils_asserts';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { ENUM__invocation_role as ENUM } from '../../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_IMAGE__viewport } from '../../../_invocations/image/INVOCATION_IMAGE__viewport';
import { INVOCATION_SD__denoise_latents_pipeline } from '../../../_invocations/sd/denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__ip_adapter } from '../../../_invocations/sd/guidance/INVOCATION_SD__ip_adapter';
import { ENUM__graph_template_name } from '../ENUM__graph_template_name';

export function GENERATION_TOOL__sd1__reference_image_2(tool: DTO__generation_tool) {
  let { graph } = tool;

  assert_false(graph.is_stub());

  /*
   *
   */

  let node__denoise = INVOCATION_SD__denoise_latents_pipeline.create_node_for(graph, ENUM.CORE__DENOISE);

  let node__image_crop_and_mask = INVOCATION_IMAGE__viewport.create_node_for(graph, ENUM.CORE__IMAGE_VIEWPORT);

  /*
   * IP ADAPTER
   */
  let node_ip_adapter_2 = INVOCATION_SD__ip_adapter.create_node_for(graph, ENUM.IP_ADAPTER__REFERENCE_IMAGES_2);

  if (!graph.nodes__are_connected_directly(node_ip_adapter_2.meta.node_id, node__denoise.meta.node_id)) {
    graph.edge__try_add_for_fields(node_ip_adapter_2.ip_adapter, node__denoise.ip_adapter);
  }

  graph.edge__try_add_for_fields(node__image_crop_and_mask.out__image_mask_cropped, node_ip_adapter_2.ip_adapter.mask);

  /*
   * UI
   */

  node_ip_adapter_2.ip_adapter.meta.field_role = 'IPA 2';

  /*
   * UI
   */

  let fields__visible: FIELD__base[] = [
    node_ip_adapter_2.ip_adapter.images,
    node_ip_adapter_2.ip_adapter.weight,
    node__image_crop_and_mask.image_mask,
    node_ip_adapter_2.ip_adapter.model__ip_adapter,
  ];
  let field_column_id = node_ip_adapter_2.ip_adapter.method.meta.field_id;
  let field_row_id = node_ip_adapter_2.ip_adapter.model__ip_adapter.meta.field_id;

  tool.view__add({
    name: ENUM__graph_template_name.REFERENCE_IMAGE_TWO,
    group: '2. References',

    //
    fields__visible,
    fields__stored: fields__visible,
    //
    field_column_id,
    field_row_id,
    //
    field_id_info__has_affect_on_generation: node_ip_adapter_2.ip_adapter.images.meta.field_id,
  });
}
